module.exports = __webpack_public_path__ + "img/pic-s4-kanapowa-menadzerka.png";